import { languageProgressArabic } from './languageProgressTranslations';
import { pageArabicTranslations, pageEnglishTranslations } from './pageTranslations';
import { supplementArabicTranslations } from './supplementTranslations';
import { attributeArabicTranslations } from './attributeTranslations';
import { operationsArabicTranslations } from './operationsTranslations';
import { staffReportArabic } from './staffReportTranslations';
import { groupReportArabic } from './groupReportTranslations';

/** Only display copy belongs here. Customer names, notes and API identifiers do not. */
const commonArabicTranslations: Record<string, string> = {
  'Student Details': 'تفاصيل الطالب',
  'Student Profile': 'ملف الطالب',
  'Manage Phones': 'إدارة أرقام التليفون',
  'Missing group details': 'تفاصيل الجروب غير المسجلة',
  'Group result pages': 'صفحات نتائج الجروبات',
  'Link group to registration · Set delivery mode': 'ربط الجروب بالتسجيل · تحديد نوع الحضور',
  'Uses the selected group and approval reason above.': 'يستخدم الجروب المختار وسبب الاعتماد المكتوب بالأعلى.',
  'Student Status': 'حالة الطالب',
  'Delivery Mode': 'نوع الحضور',
  'Arabian Academy CRM': 'Arabian Academy CRM',
  'Saved successfully.': 'تم الحفظ بنجاح.',
  'Registration': 'التسجيل',
  'Registration Date & Time': 'تاريخ ووقت التسجيل',
  'Personal Details': 'البيانات الشخصية',
  'Gender / Date of Birth': 'النوع / تاريخ الميلاد',
  'Qualification / Job': 'المؤهل / الوظيفة',
  'View source details': 'عرض تفاصيل المصدر',
  'Acquisition Source Details': 'تفاصيل مصدر العميل',
  'Close source details': 'إغلاق تفاصيل المصدر',
  'Auto Assigned': 'معروف تلقائيًا',
  'Waiting for Group': 'في انتظار مجموعة',
  'Assigned': 'تم الإسناد',
  'Edit responsible employee': 'تعديل الموظف المسؤول',
  'Responsible employee correction': 'تصحيح الموظف المسؤول',
  'Recognized from the current Sales link.': 'معروف من ربط العميل الحالي بالمبيعات.',
  'Primary Phone': 'رقم التليفون الأساسي',
  'Saved alternate phones': 'الأرقام البديلة المسجلة',
  'Loading phone permissions': 'جاري مراجعة صلاحية تعديل الأرقام',
  'Could not load phone permissions.': 'تعذر تحميل صلاحيات الأرقام.',
  'Add alternate phone numbers': 'إضافة أرقام بديلة',
  'New numbers are added to alternate phones; existing numbers stay unchanged.': 'الأرقام الجديدة هتتضاف للأرقام البديلة، والأرقام الموجودة هتفضل زي ما هي.',
  'Please enter valid phone numbers.': 'من فضلك ادخل أرقام تليفون صحيحة.',
  'These phone numbers are already saved.': 'الأرقام دي مسجلة بالفعل.',
  'Could not save phone numbers.': 'تعذر حفظ أرقام التليفون.',
  'Use up to 10 alternate phone numbers': 'مسموح بحد أقصى ١٠ أرقام بديلة',
  'Close phones': 'إغلاق إدارة الأرقام',
  'Alternate phone belongs to another registered customer': 'الرقم البديل مسجل لعميل تاني بالفعل',
  'Invalid alternate phone number': 'رقم التليفون البديل غير صحيح',
  'Current Course': 'الكورس الحالي',
  'Old System': 'السيستم القديم',
  'Expense reporting': 'تصنيف المصروف',
  'Expense classification': 'نوع المصروف',
  'Daily expense': 'مصروف يومي',
  'Monthly expense': 'مصروف شهري',
  'Add Monthly Expense': 'إضافة مصروف شهري',
  'Daily activity net': 'صافي النشاط اليومي',
  'Period activity net': 'صافي نشاط الفترة',
  'Monthly net': 'صافي الشهر',
  'Monthly net to date': 'صافي الشهر حتى اليوم',
  'Month expenses to date': 'مصروفات الشهر حتى اليوم',
  'Month expenses': 'مصروفات الشهر',
  'Daily activity expenses': 'مصروفات النشاط اليومي',
  'Daily expenses only; monthly costs excluded': 'مصروفات يومية فقط، بدون المصروف الشهري',
  'Income minus daily expenses; monthly costs excluded': 'الإيراد ناقص المصروفات اليومية، بدون المصروف الشهري',
  'Income minus daily and classified monthly expenses': 'الإيراد ناقص المصروفات اليومية والمصروفات المصنفة لهذا الشهر',
  'Daily expenses in the last 7 days': 'المصروفات اليومية لآخر ٧ أيام',
  'Last day activity net': 'صافي نشاط آخر يوم',
  'Cash decreases on the payment date; daily income stays gross.': 'يُخصم من الخزنة بتاريخ الدفع، والإيراد اليومي يظل كاملًا.',
  'No branch assigned': 'لا يوجد فرع محدد للحساب',
  'Monthly expenses must use your assigned branch cashbox': 'المصروف الشهري يُسجّل من خزنة فرعك فقط',
  'Reporting month': 'شهر المصروف',
  'Original reporting month': 'شهر التصنيف الأصلي',
  'Monthly expenses by reporting month': 'المصروفات الشهرية حسب شهر المصروف',
  'Choose a valid reporting month': 'اختار شهرًا صحيحًا للمصروف',
  'Invalid expense reporting period': 'نوع المصروف غير صحيح',
  'Monthly expenses require the updated finance service.': 'المصروفات الشهرية تتاح بعد تحديث خدمة الحسابات.',
  'Enter only the amount paid now. Income stays gross; cash decreases on the payment day. Each weekly payment is recorded once under its reporting month.': 'سجّل المبلغ المدفوع الآن فقط. الإيراد يظل كاملًا، ويُخصم الصرف من الخزنة يوم الدفع. تُسجّل كل دفعة أسبوعية مرة واحدة تحت شهر المصروف.',
  'Unsaved changes': 'تعديلات غير محفوظة',
  'Discard this expense draft and leave?': 'هل تريد التخلص من مسودة المصروف والمغادرة؟',
  'Save the expense or choose Cancel to discard your changes.': 'احفظ المصروف أو اختر إلغاء للتخلص من التعديلات.',
  'Remove receipt image': 'إزالة صورة الإيصال',
  'Save the income or choose Cancel to discard your changes.': 'احفظ الإيراد أو اختر إلغاء للتخلص من التعديلات.',
  'Discard your unsaved student changes?': 'هل تريد التخلص من تعديلات الطالب غير المحفوظة؟',
  'Discard changes': 'التخلص من التعديلات',
  'Choose Cancel to discard the unsaved reason.': 'اختر إلغاء للتخلص من السبب غير المحفوظ.',
  'Please wait until saving finishes.': 'انتظر حتى يكتمل الحفظ.',
  'Group Membership': 'حالة الانضمام للمجموعة',
  'Responsible employee': 'الموظف المسؤول',
  'Save responsible employee': 'حفظ الموظف المسؤول',
  'Responsible employee saved': 'تم حفظ الموظف المسؤول',
  'Could not save responsible employee.': 'تعذر حفظ الموظف المسؤول.',
  'Reception': 'الاستقبال',
  'Certificate preview for {0}': 'معاينة شهادة {0}',
  'Certificate preview could not load.': 'تعذر تحميل معاينة الشهادة.',
  'Preparing certificate preview…': 'جارٍ تجهيز معاينة الشهادة…',
  'Income Description': 'وصف الإيراد',
  'Unable to load interest.': 'تعذر تحميل طلب الاهتمام.',
  'Choose file': 'اختيار ملف',
  '{0} sections': '{0} أقسام',
  'Search:': 'البحث:',
  'Enter exam title': 'اكتب عنوان الامتحان',
  'Enter full name': 'اكتب الاسم الكامل',
  'Expense Description': 'وصف المصروف',
  'Total Customer Payments (this course)': 'إجمالي مدفوعات العميل لهذا الكورس',
  '{0} enrolled': '{0} مسجلين',
  'pending': 'قيد الانتظار',
  'new': 'جديد',
  'Branch cash': 'نقدية الفرع',
  'Created by {0} · Updated {1}': 'أنشأه {0} · آخر تحديث {1}',
  'system': 'النظام',
  'employee #{0}': 'موظف رقم {0}',
  '{0} / page': '{0} لكل صفحة',
  'Current employee': 'الموظف الحالي',
  'Could not load employees.': 'تعذر تحميل الموظفين.',
  'Could not load company employees.': 'تعذر تحميل موظفي الشركة.',
  'Remote student': 'طالب أونلاين',
  'Branch scope': 'نطاق الفرع',
  'Language track': 'مسار اللغات',
  'Analytics track': 'مسار تحليل البيانات',
  'Web development': 'تطوير الويب',
  'Design track': 'مسار التصميم',
  'Course option': 'اختيار كورس',
  'Working': 'يعمل',
  'Still studying': 'ما زال يدرس',
  'Finished degree': 'أنهى الدراسة',
  'Current branch': 'الفرع الحالي',
  'Available course': 'كورس متاح',
  'No capacity limit': 'بدون حد أقصى للسعة',
  'Schedule not provided': 'الجدول غير مسجل',
  '{0} seats': '{0} أماكن متاحة',
  'Mon': 'الاثنين',
  'Tue': 'الثلاثاء',
  'Wed': 'الأربعاء',
  'Thu': 'الخميس',
  'Fri': 'الجمعة',
  'Sat': 'السبت',
  'Sun': 'الأحد',
  'Full name is required.': 'الاسم الكامل مطلوب.',
  'Full name must include at least four names.': 'الاسم الكامل لازم يتكون من أربعة أسماء على الأقل.',
  'Phone number is required.': 'رقم الموبايل مطلوب.',
  'Email address is required.': 'البريد الإلكتروني مطلوب.',
  'Branch is required.': 'الفرع مطلوب.',
  'Course is required.': 'الكورس مطلوب.',
  'Select a stage and level for the language course.': 'اختر المرحلة والمستوى لكورس اللغة.',
  'Address is required.': 'العنوان مطلوب.',
  'Qualification is required.': 'المؤهل مطلوب.',
  'National ID is required.': 'الرقم القومي مطلوب.',
  'National ID must be exactly 14 digits.': 'الرقم القومي لازم يكون 14 رقم بالضبط.',
  'Passport number is required.': 'رقم جواز السفر مطلوب.',
  'Passport number must be 6-20 letters or numbers.': 'رقم جواز السفر لازم يكون من 6 إلى 20 حرفًا أو رقمًا.',
  'Date of birth is required for passport registration.': 'تاريخ الميلاد مطلوب عند التسجيل بجواز السفر.',
  'Gender is required for passport registration.': 'النوع مطلوب عند التسجيل بجواز السفر.',
  'Current job is required for working students.': 'الوظيفة الحالية مطلوبة للطالب الذي يعمل.',
  'Dashboard': 'لوحة المتابعة',
  'Students': 'الطلاب',
  'Customers': 'العملاء',
  'All Customers': 'كل العملاء',
  'Groups': 'المجموعات',
  'Courses': 'الكورسات',
  'Requests': 'الطلبات',
  'Interests': 'الاهتمامات',
  'Requests & Interests': 'الطلبات والاهتمامات',
  'Consultations': 'الاستشارات',
  'Consult Slots': 'مواعيد الاستشارات',
  'Consult Queue': 'طابور الاستشارات',
  'Waiting': 'الانتظار',
  'Waiting List': 'قائمة الانتظار',
  'Waiting & Insights': 'الانتظار والمتابعة',
  'Insights': 'المتابعة',
  'Calendar': 'التقويم',
  'Attendance': 'الحضور',
  'Tasks': 'المهام',
  'Manage Tasks': 'إدارة المهام',
  'Reports': 'التقارير',
  'Daily Reports': 'التقارير اليومية',
  'Announcements': 'الإعلانات',
  'History': 'السجل',
  'Profile': 'الملف',
  'Settings': 'الإعدادات',
  'Help': 'المساعدة',
  'Log out': 'تسجيل الخروج',
  'Logout': 'تسجيل الخروج',
  'Save': 'حفظ',
  'Save changes': 'حفظ التغييرات',
  'Saving...': 'جاري الحفظ...',
  'Cancel': 'إلغاء',
  'Close': 'إغلاق',
  'Close dialog': 'إغلاق النافذة',
  'Close daily summary': 'إغلاق ملخص اليوم',
  'Close task details': 'إغلاق تفاصيل المهمة',
  'Close task planning': 'إغلاق تخطيط المهام',
  'Close student details': 'إغلاق تفاصيل الطالب',
  'Confirm': 'تأكيد',
  'Confirm Action': 'تأكيد الإجراء',
  'Confirm Delete': 'تأكيد الحذف',
  'Yes, Proceed': 'أيوه، كمّل',
  'Dismiss notification': 'إغلاق التنبيه',
  'Dismiss confirmation backdrop': 'إغلاق التأكيد',
  'Close confirmation': 'إغلاق التأكيد',
  'Yes, delete': 'نعم، احذف',
  'No, keep it': 'لا، احتفظ به',
  'No, cancel': 'لا، إلغاء',
  'Yes, approve': 'نعم، وافق',
  'Yes, proceed': 'نعم، أكمل',
  'Yes, override': 'نعم، تجاوز الاختبار',
  'Yes, mark overdue': 'نعم، سجّل التأخير',
  'Delete task?': 'حذف المهمة؟',
  'Delete Student': 'حذف الطالب',
  'Deactivate Student': 'إيقاف الطالب',
  'Confirm Deactivate': 'تأكيد الإيقاف',
  'Delete {0} ({1})? Existing approval rules apply.': 'هل تريد حذف {0} ({1})؟ سيتم تطبيق قواعد الموافقة الحالية.',
  'Deactivate {0} ({1})? Existing approval rules apply.': 'هل تريد إيقاف {0} ({1})؟ سيتم تطبيق قواعد الموافقة الحالية.',
  'Delete task "{0}"? This cannot be undone.': 'هل تريد حذف المهمة "{0}"؟ لا يمكن التراجع عن هذا الإجراء.',
  'Delete attempt?': 'حذف المحاولة؟',
  'Delete this attempt? This cannot be undone.': 'هل تريد حذف هذه المحاولة؟ لا يمكن التراجع عن هذا الإجراء.',
  'Delete material?': 'حذف المادة؟',
  'Delete "{0}"? This cannot be undone.': 'هل تريد حذف "{0}"؟ لا يمكن التراجع عن هذا الإجراء.',
  'Confirm approval': 'تأكيد الموافقة',
  'Approve this expense entry?': 'هل تريد الموافقة على بند المصروفات هذا؟',
  'Approve {0} expense entries?': 'هل تريد الموافقة على {0} بنود مصروفات؟',
  'Approve this income entry?': 'هل تريد الموافقة على بند الإيرادات هذا؟',
  'Approve {0} income entries?': 'هل تريد الموافقة على {0} بنود إيرادات؟',
  'Reject expense entry': 'رفض بند المصروفات',
  'Provide a reason for rejecting this expense entry': 'اكتب سبب رفض بند المصروفات',
  'Reject income entry': 'رفض بند الإيرادات',
  'Provide a reason for rejecting this income entry': 'اكتب سبب رفض بند الإيرادات',
  'Restore and approve student?': 'استعادة الطالب والموافقة عليه؟',
  'Restore student?': 'استعادة الطالب؟',
  'Restore AND approve this student?': 'هل تريد استعادة هذا الطالب والموافقة عليه؟',
  'Restore this student?': 'هل تريد استعادة هذا الطالب؟',
  'Override placement test?': 'تجاوز اختبار تحديد المستوى؟',
  'Override placement test requirement for this student? They will be able to access their dashboard without taking the test.': 'هل تريد تجاوز اختبار تحديد المستوى لهذا الطالب؟ سيتمكن من فتح لوحة المتابعة بدون أداء الاختبار.',
  'Mark installment overdue?': 'تسجيل القسط متأخرًا؟',
  'Mark this installment as overdue and notify the student?': 'هل تريد تسجيل هذا القسط متأخرًا وإبلاغ الطالب؟',
  'Add': 'إضافة',
  'Edit': 'تعديل',
  'Delete': 'حذف',
  'Remove': 'إزالة',
  'Search': 'بحث',
  'Search...': 'ابحث...',
  'Filter': 'فلترة',
  'Filters': 'الفلاتر',
  'Apply': 'تطبيق',
  'Reset': 'إعادة تعيين',
  'Clear': 'مسح',
  'Refresh': 'تحديث',
  'Loading...': 'جاري التحميل...',
  'Retry': 'حاول تاني',
  'Try again': 'حاول تاني',
  'Try adjusting the search or the active filters.': 'جرّب تعديل البحث أو الفلاتر المفعّلة.',
  'View': 'عرض',
  'View details': 'عرض التفاصيل',
  'Details': 'التفاصيل',
  'Actions': 'الإجراءات',
  'Next': 'التالي',
  'Previous': 'السابق',
  'Back': 'رجوع',
  'Continue': 'كمّل',
  'Submit': 'إرسال',
  'Download': 'تنزيل',
  'Export': 'تصدير',
  'Print': 'طباعة',
  'Upload': 'رفع',
  'All': 'الكل',
  'Today': 'النهارده',
  'Yesterday': 'امبارح',
  'From': 'من',
  'To': 'لحد',
  'Name': 'الاسم',
  'Phone': 'الموبايل',
  'Email': 'الإيميل',
  'Branch': 'الفرع',
  'Status': 'الحالة',
  'Date': 'التاريخ',
  'Time': 'الوقت',
  'Notes': 'الملاحظات',
  'Comment': 'تعليق',
  'Comments': 'التعليقات',
  'Amount': 'المبلغ',
  'Total': 'الإجمالي',
  'Paid': 'مدفوع',
  'Pending': 'قيد الانتظار',
  'Payment Pending': 'في انتظار تأكيد الدفع',
  'Registered': 'متسجل',
  'Approved': 'موافق عليه',
  'Rejected': 'مرفوض',
  'Completed': 'مكتمل',
  'Cancelled': 'ملغي',
  'Active': 'نشط',
  'Inactive': 'غير نشط',
  'No results found': 'مفيش نتائج',
  'No data available': 'مفيش بيانات متاحة',
  'Something went wrong': 'حصلت مشكلة',
  'Failed to load daily summary': 'مقدرناش نحمّل ملخص اليوم',
  'Unable to save changes': 'مقدرناش نحفظ التغييرات',
  'Changes saved successfully': 'التغييرات اتحفظت',
  'Required': 'مطلوب',
  'Showing {0} of {1}': 'عرض {0} من {1}',
  'Open {0}': 'فتح {0}',
  'Yes': 'أيوه',
  'No': 'لأ',
  '{0} Branch': 'فرع {0}',
  'Found {0} student': 'لقينا {0} طالب',
  'Found {0} students': 'لقينا {0} طالب',
  'Add {0} Student': 'إضافة {0} طالب',
  'Add {0} Students': 'إضافة {0} طالب',
  '{0} certificate': '{0} شهادة',
  '{0} certificates': '{0} شهادة',
  '{0} session': '{0} حصة',
  '{0} sessions': '{0} حصة',
  'Departments': 'الأقسام',
  'Switch department': 'تغيير القسم',
  'Current department': 'القسم الحالي',
  'Close departments': 'قفل الأقسام',
  'Recently visited': 'آخر أقسام فتحتها',
  'System departments': 'أقسام السيستم',
  'Manager': 'الإدارة',
  'Sales': 'المبيعات',
  'Accountant': 'الحسابات',
  'HR': 'الموارد البشرية',
  'Marketing': 'التسويق',
  'You are offline.': 'الإنترنت مقطوع. اتأكد من الاتصال.',
};

export const receptionArabicCatalog: Record<string, string> = {
  "Calendar filters require the updated finance service.": "فلتر الشهر محتاج تحديث خدمة الحسابات. الأرقام مش هتتعرض للشهر المختار لحد ما الخدمة تدعمه.",
  "Reload expense": "إعادة تحميل المصروف",
  "Month": "الشهر",
  "Finance month": "شهر التقرير",
  "Payment date": "تاريخ الدفع",
  "Cannot record an expense for an ended month": "لا يمكن تسجيل مصروف لشهر انتهى",
  "Payment date must be within the current month and no later than today": "تاريخ الدفع لازم يكون داخل الشهر الحالي وحتى النهارده",
  "Only Reception supervisors and the executive manager can choose the payment date": "اختيار تاريخ الدفع متاح لمدير الريسبشن والمدير التنفيذي فقط",
  "Edit expense": "تعديل المصروف",
  "Correct expense": "تعديل المصروف",
  "Save correction": "حفظ التعديل",
  "Corrects the same expense and cash entry; no duplicate payment is created.": "التعديل بيصحح نفس المصروف وقيد الخزنة، من غير إنشاء دفعة أو خصم جديد.",
  "Only active paid expenses from the current month can be corrected": "يمكن تعديل المصروفات المدفوعة والسارية من الشهر الحالي فقط",
  "Expenses from ended months cannot be edited": "لا يمكن تعديل مصروفات شهر انتهى",
  "Expense changed since it was opened; reload before correcting": "المصروف اتعدل بعد فتحه. أعد تحميله قبل حفظ تعديل جديد",
  "Failed to correct expense": "تعذر تعديل المصروف",
  "Failed to load expense": "تعذر تحميل المصروف",
  "Loading expense...": "جارٍ تحميل المصروف...",
  "Only active paid expenses can be corrected": "يمكن تعديل المصروفات المدفوعة والسارية فقط",
  "This expense requires source reconciliation before correction": "المصروف ده محتاج مطابقة مصدره قبل تعديله",
  "This expense requires a verified payment date before correction": "المصروف ده محتاج تأكيد تاريخ الدفع قبل تعديله",
  "Expense corrections are restricted to Reception supervisors and the executive manager": "تعديل المصروفات متاح لمدير الريسبشن والمدير التنفيذي فقط",
  'Monthly expenses are restricted to Reception supervisors and the executive manager': 'المصروف الشهري متاح لمدير الريسبشن والمدير التنفيذي فقط',
  'Course Accounts': 'حسابات الكورسات',
  'Additional Services': 'الخدمات الإضافية',
  'Gross payments · courses and services': 'إجمالي المدفوعات قبل المرتجعات · كورسات وخدمات',
  'Remaining across course accounts': 'المتبقي على حسابات الكورسات',
  'Refunded against recorded payments': 'المبالغ المسترجعة من المدفوعات المسجلة',
  'Course price coverage for {0}': 'نسبة تغطية سعر التسجيل {0}',
  'Course price coverage · payments and credit': 'تغطية سعر التسجيل · مدفوعات ورصيد محوّل',
  'Additional course details': 'تفاصيل التسجيل الإضافية',
  'Catalog services': 'خدمات مرتبطة بالكتالوج',
  'With refunds': 'إيصالات عليها مرتجعات',
  'Filter payment history': 'تصفية سجل المدفوعات',
  'View receipt {0}': 'عرض الإيصال {0}',
  'View Receipt': 'عرض الإيصال',
  'Account details': 'تفاصيل الحساب',
  'No course accounts recorded.': 'لا توجد حسابات كورسات مسجلة.',
  'No catalog-linked service receipts recorded.': 'لا توجد إيصالات خدمات مرتبطة بالكتالوج.',
  'No matching payments.': 'لا توجد مدفوعات مطابقة للفلتر.',
  'Catalog-linked services are shown below. Older service payments remain in Payment History and account details; no separate service balance is recorded here.': 'الخدمات المرتبطة بالكتالوج ظاهرة تحت. مدفوعات الخدمات القديمة متاحة في سجل المدفوعات وتفاصيل الحساب؛ مفيش رصيد مستحق مستقل للخدمة مسجل هنا.',
  'With refunds shows original receipts with refunded amounts, not separate refund transactions.': 'الفلتر بيعرض الإيصالات الأصلية اللي عليها مبالغ مسترجعة، مش حركات استرجاع منفصلة.',
  ' — set a due date in the invoice screen.': ' — حدد ميعاد استحقاق من شاشة الإيصال.',
  ...attributeArabicTranslations,
  ...pageArabicTranslations,
  ...supplementArabicTranslations,
  ...commonArabicTranslations,
  ...operationsArabicTranslations,
  ...staffReportArabic,
  ...groupReportArabic,
  ...languageProgressArabic,
};

/** Normalize already-Arabic UI copy for the default English reception UI. */
const reverseArabicPhrases = (catalog: Record<string, string>) => Object.fromEntries(
  Object.entries(catalog).filter(([, arabic]) => /[\u0600-\u06ff]/.test(arabic)).map(([english, arabic]) => [arabic, english]),
);
export const receptionEnglishCatalog: Record<string, string> = {
  ...reverseArabicPhrases(attributeArabicTranslations),
  ...reverseArabicPhrases(pageArabicTranslations),
  ...reverseArabicPhrases(supplementArabicTranslations),
  ...reverseArabicPhrases(commonArabicTranslations),
  ...reverseArabicPhrases(operationsArabicTranslations),
  ...reverseArabicPhrases(staffReportArabic),
  ...reverseArabicPhrases(groupReportArabic),
  ...reverseArabicPhrases(languageProgressArabic),
  ...pageEnglishTranslations,
};
